module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAQlBMVEVaW1zxWVPyWFKVWljuWVNgWluJWlldWlvaWVRmWlt0WlqtWVfDWVXnWVNsWlp+WlmjWlefWle7WVa0WVbRWVThWVOEVsTuAAAAjklEQVQ4y+2SSw7CMAwFqeM4SZv+2/tfFQvhWBi3B0C87cxq9B6/uEgUb/mOuN8ZKwLges1phK6Dka54n5mzkXufl8r8ZdTi8TSACDAkRwjI/G1g+ObzybwZ52z5dDDXwTGZQptwMbbPXgtaARdbyEx7aSGd6ZWq4dIrScLsC7m0hgjOUHtGCs74Ov+1PQFWQQQL12sCJAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/favicon.png
// module id = 3111
// module chunks = 114276838955818